import React from 'react'
import { GuestLayout } from "./GuestLayout";
import { AdminLayout } from "./AdminLayout";
import { useIsAuthenticated } from "../ApplicationState/Hooks";

export const ApplicationLayout = () => {
  const isAuthenticated = useIsAuthenticated()
  return isAuthenticated ? <AdminLayout/> : <GuestLayout/>
}